import { Environment } from '@abp/ng.core';

const baseUrl = 'https://www.goprime.skin';

const oAuthConfig = {
  issuer: 'https://prime2main.goprime.skin/',
  redirectUri: baseUrl,
  clientId: 'Main_App',
  responseType: 'code',
  scope: 'offline_access Main',
  requireHttps: true,
  strictDiscoveryDocumentValidation: false,
  skipIssuerCheck: true,
  impersonation: {
    userImpersonation: true,
  }
};

export const environment = {
  production: false,
  application: {
    baseUrl,
    name: 'Main',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://prime2main.goprime.skin',
      rootNamespace: 'Ldr.Prime.Main',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  forumConfig: {
    defaultSectionTitle: 'DefaultSection',   // ✅ configurable section title
    defaultHeadingTitle: 'DefaultHeading'    // (optional) heading title too
  },
  baseContentUrl: 'https://prime2prod.blob.core.windows.net',
  gamesBaseUrl: '/lms/host/assessments/games',
  contentPaths: {
    webdocDefaults: '/general/host/ui-resources-webdoc-defaults/nov-2025',
    docDefaults: '/general/host/ui-resources-doc-defaults/nov-2025',
    imageDefaults: '/general/host/ui-resources-image-defaults/nov-2025',
    postDefaults: '/general/host/ui-post-defaults/aug-2025',
    categoryDefaults: '/general/host/ui-category-defaults/aug-2025'
  }
} as Environment;
